module.exports = __webpack_public_path__ + "media/images/flags/br-5ec13287c2da0d77a7e7d968528618ff.svg";